module.exports = __webpack_public_path__ + "img/festa8.0051494d.png";